import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";
import { ALLOWED_MODULES } from "../../constants/enums";

const MessageSequence = Loadable(
  lazy(() =>
    import("./MessageSequence").then(({ MessageSequence }) => ({
      default: MessageSequence,
    })),
  ),
);

export const MessageSequenceRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.messageSequence,
    exact: true,
    element: (
      <AuthorizedRoute
        allowFullAccess={true}
        moduleIds={[ALLOWED_MODULES.MESSAGE_SEQUENCE]}
      >
        <MessageSequence />
      </AuthorizedRoute>
    ),
  },
];
